/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlayRouteImport } from './routes/play'
import { Route as LoginLinkModalRouteImport } from './routes/login-link-modal'
import { Route as EndingRouteImport } from './routes/ending'
import { Route as EditorProjectIdRouteImport } from './routes/editor.$projectId'

const LoginLinkLazyRouteImport = createFileRoute('/login-link')()
const LoginLazyRouteImport = createFileRoute('/login')()
const HomeLazyRouteImport = createFileRoute('/home')()
const IndexLazyRouteImport = createFileRoute('/')()
const EditorIndexLazyRouteImport = createFileRoute('/editor/')()
const BooksBookSlugLazyRouteImport = createFileRoute('/books/$bookSlug')()

const LoginLinkLazyRoute = LoginLinkLazyRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login-link.lazy').then((d) => d.Route))
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const HomeLazyRoute = HomeLazyRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/home.lazy').then((d) => d.Route))
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/play.lazy').then((d) => d.Route))
const LoginLinkModalRoute = LoginLinkModalRouteImport.update({
  id: '/login-link-modal',
  path: '/login-link-modal',
  getParentRoute: () => rootRouteImport,
} as any)
const EndingRoute = EndingRouteImport.update({
  id: '/ending',
  path: '/ending',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/ending.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const EditorIndexLazyRoute = EditorIndexLazyRouteImport.update({
  id: '/editor/',
  path: '/editor/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/editor.index.lazy').then((d) => d.Route))
const BooksBookSlugLazyRoute = BooksBookSlugLazyRouteImport.update({
  id: '/books/$bookSlug',
  path: '/books/$bookSlug',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/books.$bookSlug.lazy').then((d) => d.Route),
)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/editor.$projectId.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/ending': typeof EndingRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/play': typeof PlayRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/books/$bookSlug': typeof BooksBookSlugLazyRoute
  '/editor/': typeof EditorIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/ending': typeof EndingRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/play': typeof PlayRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/books/$bookSlug': typeof BooksBookSlugLazyRoute
  '/editor': typeof EditorIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/ending': typeof EndingRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/play': typeof PlayRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/books/$bookSlug': typeof BooksBookSlugLazyRoute
  '/editor/': typeof EditorIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ending'
    | '/login-link-modal'
    | '/play'
    | '/home'
    | '/login'
    | '/login-link'
    | '/editor/$projectId'
    | '/books/$bookSlug'
    | '/editor/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ending'
    | '/login-link-modal'
    | '/play'
    | '/home'
    | '/login'
    | '/login-link'
    | '/editor/$projectId'
    | '/books/$bookSlug'
    | '/editor'
  id:
    | '__root__'
    | '/'
    | '/ending'
    | '/login-link-modal'
    | '/play'
    | '/home'
    | '/login'
    | '/login-link'
    | '/editor/$projectId'
    | '/books/$bookSlug'
    | '/editor/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  EndingRoute: typeof EndingRoute
  LoginLinkModalRoute: typeof LoginLinkModalRoute
  PlayRoute: typeof PlayRoute
  HomeLazyRoute: typeof HomeLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  LoginLinkLazyRoute: typeof LoginLinkLazyRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  BooksBookSlugLazyRoute: typeof BooksBookSlugLazyRoute
  EditorIndexLazyRoute: typeof EditorIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link-modal': {
      id: '/login-link-modal'
      path: '/login-link-modal'
      fullPath: '/login-link-modal'
      preLoaderRoute: typeof LoginLinkModalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ending': {
      id: '/ending'
      path: '/ending'
      fullPath: '/ending'
      preLoaderRoute: typeof EndingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/': {
      id: '/editor/'
      path: '/editor'
      fullPath: '/editor/'
      preLoaderRoute: typeof EditorIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/books/$bookSlug': {
      id: '/books/$bookSlug'
      path: '/books/$bookSlug'
      fullPath: '/books/$bookSlug'
      preLoaderRoute: typeof BooksBookSlugLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  EndingRoute: EndingRoute,
  LoginLinkModalRoute: LoginLinkModalRoute,
  PlayRoute: PlayRoute,
  HomeLazyRoute: HomeLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  LoginLinkLazyRoute: LoginLinkLazyRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  BooksBookSlugLazyRoute: BooksBookSlugLazyRoute,
  EditorIndexLazyRoute: EditorIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
